import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CurriculumListComponent } from './curriculum-list/curriculum-list.component';
import { CurriculumCreateComponent } from './curriculum-create/curriculum-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: CurriculumListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: CurriculumCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'curriculum-create/:id',
        component: CurriculumCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CurriculumRoutingModule { }
